<template>
  <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
    <!-- Unit -->
    <b-form-group :label="$t('patrol_logs.unit_log.unit')" label-for="unit_id">
      <b-form-input
        id="unit_id"
        v-model="formData.unit_id"
        :placeholder="$t('patrol_logs.unit_log.unit')"
        trim
      />
    </b-form-group>

    <!-- Commander -->
    <b-form-group
      :label="$t('patrol_logs.unit_log.commander')"
      label-for="id_unit_commander"
    >
      <v-select
        id="id_unit_commander"
        v-model="formData.id_unit_commander"
        :options="commanderOptionsFiltered"
        :reduce="(val) => val.value"
        :clearable="false"
        :placeholder="$t('patrol_logs.unit_log.select_commander')"
      />
    </b-form-group>

    <!-- Patrol Office -->
    <b-form-group
      :label="$t('patrol_logs.unit_log.patrol_office')"
      label-for="id_patrol_office"
    >
      <v-select
        id="id_patrol_office"
        v-model="formData.id_patrol_office"
        :options="patrolOfficerOptionsFiltered"
        :reduce="(val) => val.value"
        :clearable="false"
        :placeholder="$t('patrol_logs.patrol_log.select_patrol_officer')"
      />
    </b-form-group>

    <!-- Telephone Number -->
    <b-form-group
      :label="$t('patrol_logs.unit_log.telephone_number')"
      label-for="telephone_number"
    >
      <b-form-input
        id="telephone_number"
        v-model="formData.telephone_number"
        :placeholder="$t('patrol_logs.unit_log.telephone_number')"
        trim
      />
    </b-form-group>

    <!-- Router Number -->
    <b-form-group
      :label="$t('patrol_logs.unit_log.router_number')"
      label-for="router_number"
    >
      <v-select
        id="router_number"
        v-model="formData.router_number"
        :options="routeOptions"
        :clearable="false"
        :placeholder="$t('patrol_logs.unit_log.router_number')"
      />
    </b-form-group>

    <!-- Active -->
    <b-form-group :label="$t('patrol_logs.unit_log.active')" label-for="active">
      <b-form-checkbox id="active" v-model="formData.active" switch>
        {{ formData.active ? $t("status_active") : $t("status_inactive") }}
      </b-form-checkbox>
    </b-form-group>

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button variant="primary" class="mr-2" type="submit">
        {{ isAdd ? $t("actions.add") : $t("actions.update") }}
      </b-button>
      <b-button variant="outline-secondary" type="reset">
        {{ $t("actions.cancel") }}
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BFormCheckbox, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, computed } from "@vue/composition-api";

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    vSelect,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    commanderOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const onSubmit = () => {
      if (props.formData.id_unit_commander === props.formData.id_patrol_office) {
        this.$toast.error("Commander y Patrol Officer no pueden ser el mismo");
        return;
      }
      emit("submit");
    };

    const onReset = () => {
      emit("reset");
    };

    const commanderOptionsFiltered = computed(() => {
      return props.commanderOptions.filter(
        (option) => option.value !== props.formData.id_patrol_office
      );
    });

    const patrolOfficerOptionsFiltered = computed(() => {
      return props.commanderOptions.filter(
        (option) => option.value !== props.formData.id_unit_commander
      );
    });

    const routeOptions = ref([
      "Ruta 1 - Centro",
      "Ruta 2 - Sur",
      "Ruta 3 - Oriente",
      "Ruta 4 - Tlatelolco",
      "Ruta 5 - Norte",
      "Ruta 6 - Ecatepec-Izcalli",
      "Ruta 7 - Vallejo-Aragon",
    ]);

    return {
      onSubmit,
      onReset,
      routeOptions,
      commanderOptionsFiltered,
      patrolOfficerOptionsFiltered
    };
  },
};
</script>
